import {
  asiakas_hasAjoneuvot,
  asiakas_hasHenkilöt,
  asiakas_hasTuotteet,
} from "../asiakas/asiakasSettingsClass";
import { isKeikkaHandler } from "./isIfs";

export function showPumiFiAikaPickerButton(keikkaData) {
  if (!keikkaData) return false;
  return keikkaData.pumppuToimittaja.asiakasId == 8 && keikkaData.tila.isLuonnos;
}

export function showTyomaaSelectorAutocomplete(user) {
  if (!user) return false;
  return user.settings.isKeikkaAdmin;
}

export function showAsiakasSelectorAutocomplete(user) {
  if (!user) return false;
  return user.settings.isKeikkaAdmin;
}

export function showBetoniToimittaja(keikkaData) {
  if (!keikkaData) return false;
  return keikkaData.betoniToimittaja && keikkaData.betoniToimittaja.asiakasId > 0;
}
export function showPumppuToimittaja(keikkaData) {
  if (!keikkaData) return false;
  return keikkaData.pumppuToimittaja && keikkaData.pumppuToimittaja.asiakasId > 0;
}
export function showKeikkaLaskutusChain(keikkaData) {
  if (!keikkaData) return false;
  if (keikkaData.auth.isKeikkaAdmin) return true;
  if (keikkaData.asiakas.auth.edit) return true;
  if (keikkaData.tyomaa.auth.createKeikka) return true;
  //if (keikkaData.asiakas.auth.isAsiakasAdmin) return true; // this is a function,  maybe not needed
  return false;
}
export function showEdgeDrawer(keikkaData, user) {
  if (!keikkaData || !user) return false;
  return true;
}
export function showGlobalDrawer(user) {
  if (!user) return false;
  return true;
}
export function showToiminnot_Edge(keikkaData, user) {
  if (!keikkaData && !user) return false;
  if (keikkaData.auth?.isKeikkaAdmin) return true;
  if (user.isAnyAdmin) return true;
  return false;
}
// export function showLaskutusTab(keikkaData, keikkaLasku, user) {
//   if (!keikkaData || !user) return false;
//   try {
//     const _saaLuodaLaskun_pumppu = saaLuodaLaskun(user, keikkaData.pumppuAsiakas);
//     if (_saaLuodaLaskun_pumppu) return true;
//     const _saaLuodaLaskun_betoni = saaLuodaLaskun(user, keikkaData.betoniAsiakas);
//     if (_saaLuodaLaskun_betoni) return true;
//     const _saaLuodaLaskun_lattia = saaLuodaLaskun(user, keikkaData.lattiaAsiakas);
//     if (_saaLuodaLaskun_lattia) return true;
//     const _laskuttajaAsiakasPumppu = keikkaData.laskutus.getLaskuttajaAsiakas(keikkaData, "pumppu");
//     const _saaLuodaLaskun = _laskuttajaAsiakasPumppu.auth.getAsiakasPersonSetting(5);
//     if (_saaLuodaLaskun) return true;
//   } catch (e) {
//     console.log(e);
//     return false;
//   }
// }
export function showHintaBanner(keikkaData, keikkaLasku, user) {
  if (!keikkaLasku || !keikkaData || !user) return false;
  try {
    // const _saaNähdäHinnat = saaNähdäHinnat(user, keikkaData, keikkaLasku);
    // if (!_saaNähdäHinnat) return false;
    // if keikkaData.tila.keikkaTilaId is 3,4,5 or 9 then show
    const showByKeikkaTilaId = [3, 4, 5, 9, 10, 12, 13, 100].includes(keikkaData.tila.keikkaTilaId);
    if (!showByKeikkaTilaId) return false;
    const showByKeikkaLaskuStatusTypeId = keikkaLasku?.keikkaLaskuStatusTypeId > 9;
    if (!showByKeikkaLaskuStatusTypeId) return false;
    return true;
  } catch (e) {
    console.log(e);
    return false;
  }
}
export function showAsiakasHenkiöt(user, asiakas) {
  if (!asiakas || !user) return false;
  if (user.isAnyAdmin) return true;
  if (!asiakas.auth.isAsiakasAdmin) return false;
  if (asiakas_hasHenkilöt(asiakas)) return true;
  return false;
}

export function showTuotteet_Global(user, asiakas) {
  return showTuotteet_Tab(user, asiakas);
}

export function showTuotteet_Tab(user, asiakas) {
  if (!user) return false;
  if (!asiakas) return false;
  if (!asiakas_hasTuotteet(asiakas)) return false;

  if (asiakas.auth.isAsiakasAdmin) return true;
  if (user.isAnyAdmin) return true;
  if (
    user.oletusAdminYritysId &&
    user.isTuoteAdmin &&
    (user.isPumppuAdmin || user.isBetoniAdmin || user.isLattiaAdmin || user.isSystemAdmin)
  )
    return true;
  return false;
}
export function showAjoneuvot(user, asiakas) {
  if (!user || !asiakas) return false;
  if (!asiakas_hasAjoneuvot(asiakas)) return false;
  if (user.oletusAdminYritysId && user.isKeikkaAdmin && user.isPumppuAdmin) return true;
  return false;
}
export function showHinnastot(user) {
  if (!user) return false;
  if (
    user.oletusAdminYritysId &&
    user.isHinnastoAdmin &&
    (user.isPumppuAdmin || user.isBetoniAdmin || user.isLattiaAdmin || user.isSystemAdmin)
  )
    return true;
  return false;
}

export function showViestitTab(keikkaData, user) {
  if (!keikkaData || !user) return false;
  return keikkaData.auth.isKeikkaAdmin || user.isSystemAdmin;
}
// eslint-disable-next-line no-unused-vars
export function showAsetuksetTab(keikkaData, user) {
  return user.isSystemAdmin;
}

export function showDeleteKeikkaIcon(keikkaData, user) {
  if (!keikkaData || !user) return false;
  return keikkaData.auth.originalEdit && keikkaData.tila.keikkaTilaId < 2;
}

export function showBetoniTab(keikkaData) {
  return keikkaData.toimitus.hasBetoni;
}
export function showPumppuTab(keikkaData) {
  return keikkaData.toimitus.hasPumppu;
}
// export function showTarjousTab(user, keikkaData) {
//   return saaNähdäTarjouksen(keikkaData, user);
// }
// eslint-disable-next-line no-unused-vars
// export function showToimitusTab(keikkaData, toimitus, user) {
//   return allowEditPumppuToimitusData(toimitus, keikkaData);
// }

export function showLattiaTab(keikkaData) {
  return keikkaData.toimitus.hasLattia;
}

export function showNotificationsButton(keikkaData) {
  if (!keikkaData) return false;
  if (keikkaData.tila.muokkausTila) return false;
  if (keikkaData.tila.keikkaTilaId == 4) return true;
  if (keikkaData.tila.keikkaTilaId == 5) return true;
  return false;
}

export function showPumiFiAttachments(keikkaData) {
  return (
    keikkaData.pumppuToimittaja.asiakasId === 8 &&
    keikkaData.foreignKey?.length > 2 &&
    keikkaData.auth.isAnyAdmin
    // && stepLog.isImported.isConfirmed
  );
}

export function showKalleUrhoOyToiminnot(keikkaData) {
  if (!keikkaData.auth.isPumppuAdmin) return false;
  if (keikkaData.pumppuToimittaja.asiakasId === 8 || keikkaData.pumppuToimittaja.asiakasId === 62)
    return true;
  return false;
}
// eslint-disable-next-line no-unused-vars
export function showProcessTab(keikkaData, user) {
  // same as showSeurantaTab
  return false;
}
export function showSeurantaTab(keikkaData, user) {
  return showProcessTab(keikkaData, user);
}
export function showTilausErrors(keikkaData) {
  return keikkaData.auth.edit && keikkaData.tila.keikkaTilaId < 5;
}

export function showVehicle(keikkaData, user, stepLog) {
  try {
    if (
      !keikkaData ||
      !keikkaData.pumppu ||
      !keikkaData.pumppu.vehicle ||
      keikkaData.pumppu.vehicle.vehicleRegNo == null ||
      keikkaData.tyomaa.tyomaaId == 0 ||
      keikkaData.pumppu.vehicle.hasError ||
      !user ||
      !stepLog
    ) {
      return false;
    }
    // 3 = Käsittelyssä, 4 = Toimitusvalmis, 5 = toimitus meneillään, 9 = toimitettu
    // jos ei ole yksi noista niin ei näytetä
    // täytyy olla 3,4,5 tai 9
    if (![3, 4, 5, 9, 10, 12, 13, 100].includes(keikkaData.tila.keikkaTilaId)) {
      return false;
    }

    // check if hidden by admin
    const _hiddenByAdmin = !stepLog.showVehicleInfo;
    if (_hiddenByAdmin) {
      return false;
    }

    // show if admin
    const _isKeikkaHandler = isKeikkaHandler(keikkaData, user, stepLog);
    if (_isKeikkaHandler) return true;

    // näytä toimitetun keikan ajoneuvo
    if (keikkaData.tila.keikkaTilaId == 9) return true;

    // näytä jos on keikkaAdmin
    if (keikkaData.auth.isKeikkaAdmin) return true;

    // ei näytetä ellei ole toimitusvalmis
    if (keikkaData.tila.keikkaTilaId < 4) return false;

    // calc how long until pumppuaika from now
    // näytetään mikäli tilaukseen on alle 28h aikaa
    const _pumppuAika = keikkaData.pumppu.pumppuAika;
    const _pumppuAikaDate = new Date(_pumppuAika);
    const _now = new Date();
    const _diff = _pumppuAikaDate.getTime() - _now.getTime();
    const _diffMinutes = Math.round(_diff / 60000);
    const _diffHours = Math.round(_diffMinutes / 60);
    if (_diffHours < 28) return true;

    return false;
  } catch (e) {
    console.log(e);
  }
}
export function showPumpparit(keikkaData, user, stepLog) {
  try {
    if (!showVehicle(keikkaData, user, stepLog)) return false;
    return (
      keikkaData.pumppu.pumppariList != null &&
      keikkaData.pumppu.pumppariList.length > 0 &&
      keikkaData.pumppu.pumppariList[0].personFirstName &&
      keikkaData.pumppu.pumppariList[0].personFirstName.length > 1
    );
  } catch (e) {
    console.log(e);
    return false;
  }
}
